export default __webpack_public_path__ + "static/media/nda-header-bg.819652ff.jpg";